module.exports = __webpack_public_path__ + "img/develop.fa7b50b2.png";